var _path, _path2, _path3, _path4, _path5, _path6, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconLogoSymbolH22(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34,
    height: 22,
    viewBox: "0 0 34 22",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.4968 3.52663V0.447754L0 4.31035V21.72L14.66 18.6971V21.72L27.0294 19.145L30.5226 21.72V18.4172L33.0995 17.9134V0.447754L18.4968 3.52663Z",
    fill: "url(#paint0_linear_1272_2165)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.29492 13.6591L7.38726 8.56494L10.4796 13.6591H4.29492Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.489 13.771C16.0071 13.771 17.2377 12.568 17.2377 11.084C17.2377 9.59999 16.0071 8.39697 14.489 8.39697C12.9709 8.39697 11.7402 9.59999 11.7402 11.084C11.7402 12.568 12.9709 13.771 14.489 13.771Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8055 8.50903H23.5371V13.6592H28.8055V8.50903Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0504 10.9429L17.9043 13.0408L18.6332 13.7533L20.7793 11.6554L20.0504 10.9429Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7516 8.42992L19.6055 10.5278L20.3343 11.2403L22.4804 9.14242L21.7516 8.42992Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1272_2165",
    x1: 30.8515,
    y1: 26.0753,
    x2: 14.7682,
    y2: 8.4303,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB334"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9825,
    stopColor: "#F02826"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLogoSymbolH22);
export default __webpack_public_path__ + "static/media/IconLogoSymbolH22.0669ac84342ce305f67e269cd15b72fb.svg";
export { ForwardRef as ReactComponent };